'use client';

import Cookies from 'js-cookie';
import Script from 'next/script';
import type OsanoConsentObject from '@alltrails/types/OsanoConsentObject';


const getConsentAction = (): 'grant' | 'revoke' => {
  // Can't default to 'revoke' as suggested by Meta. This usually runs after Osano is initialized.
  // https://alltrails.atlassian.net/browse/SEOMKT-555
  if (typeof window === 'undefined') {
    return 'revoke';
  }
  try {
    const atOsanoCookie = Cookies.get('at_osano');
    if (atOsanoCookie) {
      const parsed = JSON.parse(atOsanoCookie);
      const consentObj: OsanoConsentObject = parsed.consent;
      if (consentObj?.MARKETING === 'ACCEPT') {
        return 'grant';
      }
    }
  } catch {
    // Cookie missing or unparseable. Default to revoke
  }
  return 'revoke';
};

export default function FacebookPixel({ userId }: { userId?: number }) {
  const consentAction = getConsentAction();

  return (
    <>
      <Script id="facebook-pixel" strategy="afterInteractive">
        {`!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

    fbq('consent', '${consentAction}');

    if(${userId}) {
      fbq('init', '${process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID}', {
        external_id: '${userId}'
      });
    } else {
      fbq('init', '${process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID}');
    }
    fbq('track', 'PageView');`}
      </Script>
      <noscript>
        {/* eslint-disable-next-line jsx-a11y/alt-text, @next/next/no-img-element */}
        <img
          loading="lazy"
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID}&ev=PageView&noscript=1`}
        />
      </noscript>
    </>
  );
}
